import { render, staticRenderFns } from "./TheDashboardSidebar.vue?vue&type=template&id=2261f138&"
import script from "./TheDashboardSidebar.vue?vue&type=script&lang=js&"
export * from "./TheDashboardSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TheDashboardSidebar.vue?vue&type=style&index=0&id=2261f138&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports